// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"0fe6600e","232":"d2b7920a","787":"064e410b","923":"0b3eba08","948":"7e73dad0"}[chunkId] + ".chunk.js";
};